import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from './Extras.page';
import { formWrapper } from '@client/new/pages/challenges/view/Challenges.view.css';
import { useContentFormVM } from './viewModel/extrasForm.viewModel';
import { LinkForm } from './components/LinkForm';
import { ContentLegacyGuideForm } from './components/ContentLegacyGuideForm';
import { ExtrasTabModal } from './components/ExtrasTabModal';
import { DeleteContentModal } from './components/DeleteContentModal';
import { ContentSlidesForm } from './components/ContentSlidesForm';

export const ExtrasForms = () => {
  const vm = extrasVM.useValue();

  const mode = vm.modalMode;
  const formVM = useContentFormVM(vm.currentId);

  const isSideModalOpen =
    (mode === 'edit' || mode === 'create') &&
    ['ContentLink', 'ContentLegacyGuide', 'ContentSlides'].includes(
      vm.formType,
    );

  return (
    <>
      {/* Delete confirmation modal */}
      <DeleteContentModal
        isOpen={mode === 'delete'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmDelete')}
      />

      <ExtrasTabModal
        isOpen={
          (mode === 'edit' || mode === 'create') && vm.formType === 'ContentTab'
        }
        onClose={() => vm.dispatch('CloseModal')}
        mode={mode as 'edit' | 'create'}
        onSubmit={(data) => vm.dispatch('SaveTab', data)}
        value={formVM?.values.name}
      />

      <SideModal
        isOpen={isSideModalOpen}
        onClose={() => vm.dispatch('CloseModal')}
        noSpacing
      >
        {formVM && (
          <div className={formWrapper}>
            {(() => {
              switch (formVM.formType) {
                case 'ContentLink':
                  return <LinkForm {...formVM} />;
                case 'ContentLegacyGuide':
                  return <ContentLegacyGuideForm {...formVM} />;
                case 'ContentSlides':
                  return <ContentSlidesForm {...formVM} />;
                default:
                  return null;
              }
            })()}
          </div>
        )}
      </SideModal>
    </>
  );
};
